import React,{memo} from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function SpyButton({ id }) {
  const { t } = useTranslation();

  return (
    <>
      {!!id ? (
        <Link
          to={{
            pathname: `/chats`,
            state: {
              spyConversationId: id,
              isByManager: false,
              isSpyOperator: true,
            },
          }}
        >
          {t("View")}
        </Link>
      ) : (
        <span
          className="text-primary"
          style={{ opacity: 0.7, cursor: "not-allowed" }}
        >
          {t("View")}
        </span>
      )}
    </>
  );
}

export default memo(SpyButton);
